import isFinite from 'lodash/isFinite';

import { CHART_TAIL_TYPES } from 'store/scenes/distributions/chart/enums';

const PDS_COUNT = 500;

export const getPds = (xMin, xMax, pdFn, pdsCount = PDS_COUNT) => {
  const step = Math.abs(xMax - xMin) / pdsCount;

  const pds = [];

  for (let x = xMin; x < xMax; x += step) {
    pds.push({ x, y: pdFn(x) });
  }
  return pds;
};

export const getPdsForGraphTicks = (mean, stdev) => {
  const xAxis = [];
  const xMin = mean - (4 * stdev);
  const xMax = mean + (4 * stdev);
  for (let i = xMin; i < xMax; i += stdev) {
    xAxis.push(i);
  }

  return xAxis;
};

export const getCutoffsByAlpha = (alpha, pdFn, invFn) => {

  const leftCutoffX = invFn(alpha);
  const leftCutoffY = pdFn(leftCutoffX);

  const rightCutoffX = invFn(1 - alpha);
  const rightCutoffY = pdFn(rightCutoffX);

  return ({
    left: { x: leftCutoffX, y: isFinite(leftCutoffY) ? leftCutoffY : 0 },
    right: { x: rightCutoffX, y: isFinite(rightCutoffY) ? rightCutoffY : 0 }
  });
};

export const getCutoffsByCutoffXValues = (pdFn, leftCutoffX, rightCutoffX) => {
  const leftCutoffY = pdFn(leftCutoffX);
  const rightCutoffY = pdFn(rightCutoffX);

  return ({
    left: { x: leftCutoffX, y: isFinite(leftCutoffY) ? leftCutoffY : 0 },
    right: { x: rightCutoffX, y: isFinite(rightCutoffY) ? rightCutoffY : 0 }
  });
};

export const getAlphaByCutoff = ({ type, value }, cdfFn) =>
  type === 'left' ? cdfFn(+value) : 1 - cdfFn(+value);

export const getAlphaByCutoffsAndTailType = (cdfFn, leftCutoffValue, rightCutoffValue, tailType) => {

  if (tailType === CHART_TAIL_TYPES.CENTER) {
    return (1 - (cdfFn(leftCutoffValue) + (1 - cdfFn(rightCutoffValue))));
  } else if (tailType === CHART_TAIL_TYPES.BOTH) {
    return (cdfFn(leftCutoffValue) + (1 - cdfFn(rightCutoffValue)));
  } else if (tailType === CHART_TAIL_TYPES.RIGHT) {
    return (1 - cdfFn(rightCutoffValue));
  } else {
    return cdfFn(leftCutoffValue);
  }
};

// We need this to prevent returning infinity
export const getMaxAlphaRange = alpha => {
  let newAlpha = alpha;

  if (alpha > 0.99999) {
    newAlpha = 0.99999;
  } else if (alpha < 0.00001) {
    newAlpha = 0.00001;
  }
  return newAlpha;
};
